import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SFChatService {
  private maxTries = 3;
  private retryCount = 0;
  sfChatUserId = "";
  sfChannelName = "";
  sfChannelUrl = "";
  sfChatScrtUrl = "";

  public initialize(userDetail: any) {

    var hostname = window.location.hostname;
    if (hostname.includes("evolvestage") || hostname.includes("evolveqa1") || hostname.includes("evolvestage2") || hostname.includes("evolveqa2")) {
      this.sfChatUserId = "00DEm00000OlfI1";
      this.sfChannelName = "Evolve_Chat";
      this.sfChannelUrl = "https://focus--qa.sandbox.my.site.com/ESWEvolveChat1772814504307";
      this.sfChatScrtUrl = "https://focus--qa.sandbox.my.salesforce-scrt.com";
    }
    else if (hostname.includes("evolvedev") || hostname.includes("evolvedv") || hostname.includes("localhost")) {
      this.sfChatUserId = "00Dcb000006qkmT";
      this.sfChannelName = "WF_Chat_Messaging_Channel";
      this.sfChannelUrl = "https://focus--voicedev.sandbox.my.site.com/ESWWFChatMessagingChan1767718723171";
      this.sfChatScrtUrl = "https://focus--voicedev.sandbox.my.salesforce-scrt.com";
    }
    else if (hostname.includes("evolve.winfieldunited.com")) {
      this.sfChatUserId = "00DG0000000jQYr";
      this.sfChannelName = "Evolve_Chat";
      this.sfChannelUrl = "https://focus.my.site.com/ESWEvolveChat1772814504307";
      this.sfChatScrtUrl = "https://focus.my.salesforce-scrt.com";
    }
       
    const bootstrap = (window as any).embeddedservice_bootstrap;

    if (!bootstrap || !userDetail || userDetail === undefined) {
      if (this.retryCount < this.maxTries) {
        this.retryCount++;
        console.log(`SFChat not ready. Attempt ${this.retryCount} of ${this.maxTries}...`);
        setTimeout(() => this.initialize(userDetail), 1000);
      } else {
        console.error('Salesforce Chat failed to initialize.');
      }
      return;
    }

    this.executeInit(bootstrap, userDetail);
  }

  private executeInit(bootstrap: any, userDetail: any) {
    try {

      if (!userDetail) {
        console.warn('User details not found');
        return;
      }
      bootstrap.settings.language = 'en_US';

      console.log("prechatAPI" + bootstrap.prechatAPI);

      window.addEventListener("onEmbeddedMessagingReady", () => {
        if (bootstrap.prechatAPI) {
            bootstrap.prechatAPI.setVisiblePrechatFields({
              "First Name": {
                "value": userDetail.firstName,
                "isEditableByEndUser": false
              },
              "Last Name": {
                "value": userDetail.lastName,
                "isEditableByEndUser": false
              },
              "Email": {
                "value": userDetail.emailId,
                "isEditableByEndUser": false
              },
              "Phone (optional)": {
                "value": userDetail.phoneNumber,
                "isEditableByEndUser": true
              },
              "Retailer": {
                "value": userDetail.retailerName,
                "isEditableByEndUser": false
              },
            });

            bootstrap.prechatAPI.setHiddenPrechatFields({
              UserId: userDetail.userId
            });
        } else {
          console.log("prechatAPI" + bootstrap.prechatAPI);
        }
      });

      bootstrap.init(
        this.sfChatUserId,
        this.sfChannelName,
        this.sfChannelUrl,
        { scrt2URL: this.sfChatScrtUrl }
      );
    } catch (err) {
      console.error('Error during Salesforce Init:', err);
    }
  }
}
